var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", width: "800" } },
    [
      _c(
        "v-card",
        { staticClass: "fill" },
        [
          _c(
            "v-toolbar",
            { staticClass: "main", attrs: { flat: "", dark: "" } },
            [
              _c("v-toolbar-title", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.existing
                        ? "Edit Recap Addition"
                        : "New Recap Addition"
                    ) +
                    " "
                ),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close", false)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "ma-0 px-4", attrs: { fluid: "" } },
            [
              _c(
                "v-form",
                { ref: "form", attrs: { "lazy-validation": "" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-0 pt-0" },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Recap Component",
                              items: _vm.recapComponents,
                              "background-color": "input",
                              "menu-props": { offsetY: true },
                              "item-text": "name",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return !!v || "Recap component is required"
                                },
                              ],
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.recapAddition.recap_component_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.recapAddition,
                                  "recap_component_id",
                                  $$v
                                )
                              },
                              expression: "recapAddition.recap_component_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Store",
                              items: _vm.parties,
                              "background-color": "input",
                              "item-text": "name",
                              "item-value": "id",
                              disabled: !!_vm.file,
                              rules: [
                                function (v) {
                                  return (
                                    !!v || !!_vm.file || "Store is required"
                                  )
                                },
                              ],
                              outlined: "",
                              loading: _vm.loadingItems,
                              "menu-props": { maxHeight: 215, maxWidth: 650 },
                              dense: "",
                              "single-line": "",
                              "auto-select-first": "",
                              clearable: !_vm.existing,
                            },
                            model: {
                              value: _vm.recapAddition.party_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.recapAddition, "party_id", $$v)
                              },
                              expression: "recapAddition.party_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-0 pt-0" },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Billing Year",
                              items: _vm.billingYears,
                              "background-color": "input",
                              "menu-props": { offsetY: true },
                              "item-text": "name",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return !!v || "Billing Year is required"
                                },
                              ],
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.recapAddition.billing_year_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.recapAddition,
                                  "billing_year_id",
                                  $$v
                                )
                              },
                              expression: "recapAddition.billing_year_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Billing Period",
                              items: _vm.billingPeriods,
                              "background-color": "input",
                              "menu-props": { offsetY: true },
                              "item-text": "name",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return !!v || "Billing Period is required"
                                },
                              ],
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.recapAddition.billing_period_id,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.recapAddition,
                                  "billing_period_id",
                                  $$v
                                )
                              },
                              expression: "recapAddition.billing_period_id",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Amount",
                              "background-color": "input",
                              outlined: "",
                              dense: "",
                              type: "number",
                              min: "0.00",
                              step: ".01",
                              prefix: "$",
                              disabled: !!_vm.file,
                              rules: [
                                function (v) {
                                  return (
                                    !!v || !!_vm.file || "Amount is required"
                                  )
                                },
                              ],
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.recapAddition.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.recapAddition, "amount", $$v)
                              },
                              expression: "recapAddition.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "pt-0 mt-0" },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Comment",
                              "background-color": "input",
                              outlined: "",
                              dense: "",
                              rules: [
                                function (v) {
                                  return !!v || "Comment is required"
                                },
                                _vm.validateText,
                              ],
                            },
                            model: {
                              value: _vm.recapAddition.comment,
                              callback: function ($$v) {
                                _vm.$set(_vm.recapAddition, "comment", $$v)
                              },
                              expression: "recapAddition.comment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.existing
                    ? _c(
                        "v-row",
                        { staticClass: "mt-0 pt-0 mb-2" },
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-file-input", {
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                  "truncate-length": "100",
                                  label: "File",
                                  "background-color": "input",
                                  clearable: "",
                                  accept: ".xlsx",
                                  disabled: _vm.disableFileUpload,
                                },
                                on: { change: _vm.onFileChange },
                                model: {
                                  value: _vm.file,
                                  callback: function ($$v) {
                                    _vm.file = $$v
                                  },
                                  expression: "file",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2 white--text",
                      attrs: {
                        loading: _vm.downloading,
                        disabled: _vm.downloading,
                        color: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.downloadTemplate()
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-file-download-outline"),
                      ]),
                      _vm._v(" Template "),
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: {
                        color: "success",
                        loading: _vm.saving,
                        disabled: _vm.saving || _vm.disableSave,
                      },
                      on: {
                        click: function ($event) {
                          _vm.existing
                            ? _vm.saveRecapAddition()
                            : _vm.createRecapAddition()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.existing ? "Save" : "Create") + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }